import { render, staticRenderFns } from "./SuggestedTags.vue?vue&type=template&id=a01ebe70&scoped=true&"
import script from "./SuggestedTags.vue?vue&type=script&lang=js&"
export * from "./SuggestedTags.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedTags.vue?vue&type=style&index=0&id=a01ebe70&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01ebe70",
  null
  
)

export default component.exports